export class UserModel {
    name:string;
    lastname:string;
    email:string;
    password:string;
    phone:string;
    address:string;
}